
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#7e57c2","d":"M23 4c-6.617 0-12 7.27-12 16.205 0 4.834 1.582 9.169 4.078 12.136A2.986 2.986 0 0015 33a3 3 0 103-3 2.96 2.96 0 00-.897.152C15.206 27.731 14 24.175 14 20.205 14 12.924 18.037 7 23 7c3.837 0 7.111 3.547 8.404 8.518 1.122.346 2.237.782 3.33 1.308C33.579 9.508 28.759 4 23 4z"}}),_c('path',{attrs:{"fill":"#7e57c2","d":"M35.507 20.084c-3.947-2.392-8.374-3.442-12.182-2.959A2.982 2.982 0 0021 16a3 3 0 100 6 2.995 2.995 0 002.789-1.912c3.118-.379 6.812.531 10.163 2.563 6.403 3.881 9.67 10.569 7.282 14.911-.827 1.504-2.286 2.572-4.218 3.09-2.286.611-5.007.394-7.727-.528a24.508 24.508 0 01-2.725 2.168c2.552 1.117 5.196 1.704 7.669 1.704 1.24 0 2.438-.147 3.559-.447 2.741-.733 4.841-2.304 6.071-4.542 3.153-5.731-.596-14.22-8.356-18.923z"}}),_c('path',{attrs:{"fill":"#7e57c2","d":"M35 28.992C35 27.34 33.657 26 32 26s-3 1.34-3 2.992c0 .669.228 1.281.6 1.779-1.279 2.802-3.744 5.567-7.062 7.578-3.865 2.344-8.185 3.202-11.555 2.302-1.932-.518-3.391-1.586-4.218-3.09-1.702-3.094-.521-7.376 2.61-10.988a22.94 22.94 0 01-.706-3.575c-5.07 4.797-7.109 11.323-4.532 16.009 1.23 2.238 3.33 3.809 6.071 4.542 1.121.3 2.318.447 3.559.447 3.346 0 7.007-1.068 10.326-3.08 3.836-2.325 6.683-5.577 8.209-8.962C33.815 31.801 35 30.541 35 28.992z"}})])
          )
        }
      }
    